<template>
  <div>
    <div :style="{ color: labelColor }">{{ label }}</div>
    <div class="h-heading-h2" :style="{ color: valueColor }">
      {{ value }}
      <div class="notice h-text-3" v-if="notice">{{ notice }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'h-information-label',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: 'Label',
    },
    value: {
      type: String,
      default: 'value',
    },
    notice: {
      type: String,
    },
    labelColor: {
      type: String,
    },
    valueColor: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.notice {
  max-width: 500px;
}
</style>
